import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "../lib/constants";

const renderAnswer = (text) => {
  const parts = text.split("Service Areas page");
  if (parts.length === 1) return text;
  return parts.map((part, i) => (
    <span key={i}>
      {part}
      {i < parts.length - 1 && (
        <Link to="/service-areas" className="text-brand font-semibold underline underline-offset-2 hover:text-brand-dark transition-colors duration-300">
          Service Areas page
        </Link>
      )}
    </span>
  ));
};

export const FAQAccordion = ({ items, testIdPrefix = "faq", closingNote = true }) => {
  const [open, setOpen] = useState(null);

  return (
    <div data-testid={`${testIdPrefix}-accordion`}>
      <div className="divide-y divide-brand-line/70 border-y border-brand-line/70">
        {items.map((item, i) => (
          <div key={item.q}>
            <button
              onClick={() => setOpen(open === i ? null : i)}
              data-testid={`${testIdPrefix}-question-${i + 1}`}
              aria-expanded={open === i}
              className="w-full flex items-center justify-between gap-6 py-5 text-left group"
            >
              <span className="font-display font-medium text-base sm:text-lg text-brand-ink group-hover:text-brand transition-colors duration-300">
                {item.q}
              </span>
              <span className={`shrink-0 w-8 h-8 rounded-full border border-brand-line flex items-center justify-center text-brand transition-transform duration-300 ${open === i ? "rotate-180 bg-brand text-white border-brand" : ""}`}>
                <ChevronDown size={16} />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {open === i && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="pb-6 pr-10 text-sm sm:text-base text-brand-muted leading-relaxed" data-testid={`${testIdPrefix}-answer-${i + 1}`}>
                    {renderAnswer(item.a)}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
      {closingNote && (
        <div className="mt-8 bg-brand-mist/50 border border-brand-line/60 rounded-2xl px-6 py-5 flex flex-wrap items-center justify-between gap-4" data-testid={`${testIdPrefix}-closing-note`}>
          <p className="text-sm sm:text-base text-brand-ink font-medium">
            Still have a question? Call{" "}
            <a href={BUSINESS.phoneHref} className="text-brand font-semibold underline underline-offset-2" data-testid={`${testIdPrefix}-closing-call`}>
              {BUSINESS.phoneDisplay}
            </a>{" "}
            or send us your cleaning enquiry.
          </p>
          <Link
            to="/get-estimate"
            data-testid={`${testIdPrefix}-closing-estimate`}
            className="group inline-flex items-center gap-2 text-sm font-semibold text-brand"
          >
            Get an Estimate
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      )}
    </div>
  );
};
